<template>
  <div>
    <el-card>
      <div style="padding-bottom: 1vh">
        <el-button :disabled="multipleSelection.length==0" class="el-icon-delete" type="danger" size="small" @click="deleteRows">删除
        </el-button>
        <el-button :disabled="multipleSelection.length!=1" class="el-icon-edit" type="primary" size="small" @click="openForm(true)">修改
          <!--    <el-button class="el-icon-plus" type="success" size="small" @click="openForm(false)">添加</el-button>-->
        </el-button>
      </div>

      <el-table
        v-loading="listLoading"
        :data="list"
        element-loading-text="Loading"
        stripe
        border
        :header-cell-style="{ background: '#f4f4f4', color: '#409eff' }"

        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="40" />
        <el-table-column label="序号" align="center" width="50" type="index" />
        <el-table-column label="序列号" align="center">
          <template slot-scope="scope">
            {{ scope.row.hardwareSn }}
          </template>
        </el-table-column>
        <el-table-column label="软件版本" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.softwareVersion }}
          </template>
        </el-table-column>
        <el-table-column label="硬件版本" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.hardwareVersion }}
          </template>
        </el-table-column>
        <el-table-column label="故障详情" align="center" width="500">
          <template slot-scope="scope">
            {{ scope.row.alarmName }}
          </template>
        </el-table-column>
        <el-table-column label="故障代码" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.faultCode }}
          </template>
        </el-table-column>
        <el-table-column label="故障时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.tiggerTime }}
          </template>
        </el-table-column>
        <el-table-column label="单位信息" align="center">
          <template slot-scope="scope">
            {{ scope.row.unitName }}
          </template>
        </el-table-column>
        <el-table-column label="通道信息" align="center">
          <template slot-scope="scope">
            {{ scope.row.drivewayName }}
          </template>
        </el-table-column>
        <el-table-column label="故障状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.errStatus == '1' ? 'primary' : 'warning'">
              {{ scope.row.errStatus == 1 ? '正常':'故障'}}
            </el-tag>

          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <!--form表单-->
      <el-dialog
        :title="form.id?'修改':'添加'"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="30%">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="序列号">
            <el-input v-model="form.hardwareSn" disabled/>
          </el-form-item>
          <el-form-item label="软件版本">
            <el-input v-model="form.softwareVersion" disabled/>
          </el-form-item>
          <el-form-item label="硬件版本">
            <el-input v-model="form.hardwareVersion" disabled/>
          </el-form-item>
          <el-form-item label="故障详情">
            <el-input v-model="form.alarmName" disabled/>
          </el-form-item>
          <el-form-item label="故障代码">
            <el-input v-model="form.faultCode" disabled/>
          </el-form-item>
          <el-form-item label="上报时间">
            <el-input v-model="form.tiggerTime" disabled/>
          </el-form-item>
          <!--        <el-form-item label="unitId">-->
          <!--          <el-input v-model="form.unitId" />-->
          <!--        </el-form-item>-->
          <!--        <el-form-item label="drivewayId">-->
          <!--          <el-input v-model="form.drivewayId" />-->
          <!--        </el-form-item>-->
          <el-form-item label="单位地址">
            <el-input v-model="form.unitName" disabled/>
          </el-form-item>
          <el-form-item label="通道名称">
            <el-input v-model="form.drivewayName" disabled/>
          </el-form-item>
          <el-form-item label="维修状态">
            <el-radio-group v-model="form.errStatus">
              <el-radio :label=0>故障</el-radio>
              <el-radio :label=1>恢复正常</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveRow">确 定</el-button>
      </span>
      </el-dialog>

    </el-card>
  </div>
</template>

<script>
import { getList, deleteRows, saveRow } from "@/api/errorRecord";
import { mapGetters } from "vuex";
export default {
  filters: {},
  data() {
    return {
      list: [],
      listLoading: true,
      multipleSelection: [],
      current: 1,
      total: 0,
      size: 10,
      dialogVisible: false,
      form: {}
    };
  },
  computed: {
    ...mapGetters(["userinfo"])
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.multipleSelection.length = 0;
      this.listLoading = true;
      const params = {
        netUnitId: this.userinfo.uid,
        size: this.size,
        current: this.current
      };
      getList(params).then(response => {
        this.list = response.data.data.list;
        this.total = response.data.data.total;
        this.listLoading = false;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    deleteRows() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.listLoading = true;
          const ids = [];
          this.multipleSelection.map(row => ids.push(row.id));
          deleteRows(ids).then(response => {
            this.listLoading = false;
            if (response.data) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.fetchData();
            } else {
              this.$message({
                type: "error",
                message: "删除失败!"
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
      } else {
        this.$message.info("请至少选择一项");
      }
    },
    openForm(hasId) {
      if (hasId) {
        this.form = JSON.parse(JSON.stringify(this.multipleSelection[0]));
      } else {
        this.form = {};
      }
      this.dialogVisible = true;
    },
    saveRow() {
      let msg = "添加";
      if (this.form.id) {
        msg = "修改";
        this.form.createTime = null;
        this.form.updateTime = null;
      }
      saveRow(this.form).then(response => {
        this.listLoading = false;
        if (response.data) {
          this.$message({
            type: "success",
            message: msg + "成功"
          });
          this.fetchData();
        } else {
          this.$message({
            type: "error",
            message: msg + "失败!"
          });
        }
      });
      this.dialogVisible = false;
    },
    handleSizeChange(val) {
      this.size = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.fetchData();
    }
  }
};
</script>
<style scoped>
.el-table--striped .el-table__body tr.el-table__row--striped.current-row td, .el-table__body tr.current-row>td {
  color: #fff;
  background-color: #a2a4a7!important;
}
::v-deep .el-table .cell {
  white-space: pre-line;
}
</style>
